import { render } from "./UserPost.vue?vue&type=template&id=2b8eea92"
import script from "./UserPost.vue?vue&type=script&lang=js"
export * from "./UserPost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__